import i18n from "i18next";
import httpBackend from 'i18next-http-backend';
import { initReactI18next } from "react-i18next";
import { getTranslations, NAMESPACE_LOCAL, NAMESPACE_REMOTE } from "./TranslationHelper";

const backendOptions = {
  loadPath: '{{lng}}|{{ns}}', 
  request: (options, url, payload, callback) => {
    try {
      const [lng, ns] = url.split('|');
      getTranslations(lng, ns).then((response) => {
        callback(null, {
          data: response,
          status: 200,
        });
      });
    } catch (error) {
      console.error(error);
      callback(null, {
        status: 500,
      });
    }
  },
};

i18n
  .use(httpBackend)
  .use(initReactI18next)
  .init({
    backend: backendOptions,
    preload: ["de", "en"],
    supportedLngs: ["de", "en"],
    lng: "de",
    lowerCaseLng: true,
    ns: [NAMESPACE_LOCAL, NAMESPACE_REMOTE],
    defaultNS: NAMESPACE_LOCAL,
    interpolation: {
      // react already safes from xss
      escapeValue: false,
    },
    react: {
      // To "useSuspense: true", <React.Suspense fallback={...}> is added to index.js
      // Otherwise "useSuspense: false" or there will be the following error:
      // Header suspended while rendering, but no fallback UI was specified.
      // Add a <Suspense fallback=...> component higher in the tree to provide
      // a loading indicator or placeholder to display.
      useSuspense: true
    }
  });

export default i18n;
